import React from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

export interface ComponentWithRouterProps {
  nagivate: NavigateFunction;
}

export function withRouter(
  Component: React.ComponentType<ComponentWithRouterProps>
) {
  function ComponentWithRouterProp(props) {
    const nagivate = useNavigate();
    return <Component {...props} nagivate={nagivate} />;
  }

  return ComponentWithRouterProp;
}
